var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/refresh"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5184 17.6551C14.9147 16.7605 17.4163 13.673 17.4163 9.99967C17.4163 5.62967 13.9013 2.08301 9.49967 2.08301C4.21926 2.08301 1.58301 6.48467 1.58301 6.48467M1.58301 6.48467V2.87467M1.58301 6.48467H3.17426H5.09801",
    stroke: "#696969",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.58301 10C1.58301 14.37 5.12967 17.9167 9.49967 17.9167",
    stroke: "#696969",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a8ea0d0abe130a3ca7f592e5aaf0ad3b.svg";
export { ForwardRef as ReactComponent };